import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class DashboardService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getHomeDashboard(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDashboard/GetDashboardStats', data, messageService);
    }

    public getServiceTypeDashboard(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDashboard/GetServiceTypeDashboard', data, messageService);
    }

    public getReportDriversDashboard(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDashboard/GetReportDriversDashboard', data, messageService);
    }

    public getReportCustomersDashboard(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDashboard/GetReportCustomersDashboard', data, messageService);
    }

    public getReportRevenueDashboard(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDashboard/GetReportRevenueDashboard', data, messageService);
    }

    public getTransactionDashboard(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDashboard/GetTransactionDashboard', data, messageService);
    }

    public exportAvgReport(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/AdminDashboard/ExportAvgReport', data, messageService);
    }

    public getTransactionAccountingDashboard(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminDashboard/GetTransactionAccountingDashboard', data, messageService);
    }
}
